<template>
  <div class="jianlu-live-wrap" :style="{ background: row.show_bg || '#000' }">
    <div class="machine-head" :style="{ color: row.show_font_color }">
      <img
        class="jianlu-live-logo jianlu-live-logo--left"
        src="https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1775121359591-20.png"
        alt=""
      />
      <div>{{ saiqu.name }}</div>
      <div>{{ row.title }}</div>
      <img
        class="jianlu-live-logo jianlu-live-logo--right"
        src="https://wa.ccachina.net/img/logo.58b57af4.png"
        alt=""
      />
    </div>
    <iframe
      class="jianlu-live-iframe"
      :src="liveUrl"
      frameborder="0"
      allowfullscreen
    />
  </div>
</template>

<script>
export default {
  name: 'ScoreJianluLive',
  props: {
    row: {
      type: Object,
      default: () => ({}),
    },
    saiqu: {
      type: Object,
      default: () => ({}),
    },
    /** 后续从服务端下发，暂写死 */
    liveUrl: {
      type: String,
      default: 'https://www.baidu.com/',
    },
  },
}
</script>

<style scoped>
.jianlu-live-wrap {
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.machine-head {
  flex-shrink: 0;
  text-align: center;
  font-size: 22px;
  line-height: 1.4;
  padding: 12px 90px 8px;
  position: relative;
}
.jianlu-live-logo {
  width: 80px;
  position: fixed;
  top: 10px;
}
.jianlu-live-logo--left {
  left: 10px;
}
.jianlu-live-logo--right {
  right: 10px;
}
.jianlu-live-iframe {
  flex: 1;
  width: 100%;
  min-height: 0;
  border: none;
  background: #000;
}
</style>



// WEBPACK FOOTER //
// ScoreJianluLive.vue?25cba760